import React from 'react';
import {useSelector} from "react-redux";
import ContentViewComponent from "../../../Component/ContentViewComponent";
import TableComponent from "../../../Component/TableComponent";
import ApiHandler from "../../../Handler/ApiHandler";
import {hasRight} from "../../../Common/UserCommon";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip} from "@mui/material";
import {Edit, DoneAll, RotateLeft} from "@mui/icons-material";
import ButtonComponent from "../../../Component/ButtonComponent";
import {initFormHandler} from "../../../Handler/FormHandler";
import {LinearProgressMainLayoutActivate, LinearProgressMainLayoutDeactivate} from "../../../Action/LinearProgressMainLayoutAction";
import {SnackbarOpen} from "../../../Action/SnackbarAction";
import TextFieldComponent from "../../../Component/TextFieldComponent";
import {dispatch} from "../../../App";
import {TableReload} from "../../../Action/TableAction";

function SettingMarkList() {
    const authenticationReducer = useSelector(state => state.AuthenticationReducer);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [openDialog, setOpenDialog] = React.useState(false);
    const [mark, setMark] = React.useState(null);
    const [isUpdateSylius, setIsUpdateSylius] = React.useState(true);
    const [isLoadingSylius, setIsLoadingSylius] = React.useState(true);

    // Sylius
    const updateSylius = () => {
        setIsLoadingSylius(true);
        ApiHandler.get({
            route: 'api_setting_mark_sylius'
        }, (response) => {
            if (response.status === 200) {
                setIsUpdateSylius(response.data.isUpdate);
            }
            else {
                dispatch(
                    SnackbarOpen({
                        text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                        variant: 'error',
                    })
                );
                setIsUpdateSylius(false);
            }

            setIsLoadingSylius(false);
        });
    };
    React.useEffect(updateSylius, []);

    // Global
    const columns = [
        {
            name: "id",
            label: "Référence",
            options: {filter: true, sort: true}
        },
        {
            name: "label",
            label: "Libellé",
            options: {filter: true, sort: true}
        },
        {
            name: "code",
            label: "Code",
            options: {filter: true, sort: true}
        },
        {
            name: "action",
            label: "Action",
            options: {filter: false, sort: false}
        }
    ];
    const getAction = (row) => {
        if ((hasRight(authenticationReducer, 'ROLE_SETTING_MARK') || hasRight(authenticationReducer, 'ROLE_SETTING_MARK_EDIT'))) {
            return (
                <>
                    <Tooltip title={'Modifier'} placement="left">
                        <IconButton
                            onClick={() => {
                                handlerForm.reset();
                                setMark(row.id);
                                handlerForm.setValue('label', row.label);
                                handlerForm.setValue('code', row.code);
                                setOpenDialog(true);
                            }}
                        >
                            <Edit style={{color: '#17a2b8'}}/>
                        </IconButton>
                    </Tooltip>
                </>
            );
        }
        else {
            return (
                <>
                    <IconButton style={{cursor: 'no-drop'}}>
                        <Edit/>
                    </IconButton>
                </>
            );
        }
    };
    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Liste des marques',
            context: 'Paramétrage',
            description: '',
            links: []
        });
    }, []);

    // Form
    const [form, setForm] = React.useState({
        label: {
            name: 'label',
            label: 'Libellé',
            textHelper: 'Saisissez le libellé de la marque.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        code: {
            name: 'code',
            label: 'Code',
            textHelper: 'Saisissez le code de la marque.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required'], equal: 2}
        }
    });
    const [isLoadingForm, setIsLoadingForm] = React.useState(false);
    const handlerForm = initFormHandler(form, setForm);
    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            setIsLoadingForm(true);
            dispatch(LinearProgressMainLayoutActivate());

            if (mark) {
                ApiHandler.post({
                    route: 'api_setting_mark_edit',
                    data: handlerForm.getData(),
                    params: {id: mark}
                }, (response) => {
                    if (response.status === 200) {
                        setOpenDialog(false);
                        dispatch(TableReload('api_setting_mark_list'));
                        setMark(null);
                        dispatch(
                            SnackbarOpen({
                                text: 'Marque modifiée avec succès.',
                                variant: 'success',
                            })
                        );

                        ApiHandler.clearCache('api_select_mark');
                        updateSylius();
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }

                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
            else {
                ApiHandler.post({
                    route: 'api_setting_mark_add',
                    data: handlerForm.getData()
                }, (response) => {
                    if (response.status === 200) {
                        setOpenDialog(false);
                        dispatch(TableReload('api_setting_mark_list'));
                        dispatch(
                            SnackbarOpen({
                                text: 'Marque créée avec succès.',
                                variant: 'success',
                            })
                        );

                        ApiHandler.clearCache('api_select_mark');
                        updateSylius();
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }

                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
        }
    };
    React.useEffect(handlerForm.start, []);

    return (
        <ContentViewComponent loading={false} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'api_setting_mark_list'}
                title={'Marques'}
                columns={columns}
                actionFirst={
                    (hasRight(authenticationReducer, 'ROLE_SETTING_MARK') || hasRight(authenticationReducer, 'ROLE_SETTING_MARK_ADD')) ?
                        {
                            label: 'Ajouter une marque', onClick: () => {
                                setMark(null);
                                handlerForm.reset();
                                setOpenDialog(true);
                            }
                        } : false
                }
                actionSecond={
                    (hasRight(authenticationReducer, 'ROLE_SETTING_MARK') || hasRight(authenticationReducer, 'ROLE_SETTING_MARK_LIST')) ?
                        {
                            label: isUpdateSylius ? <span>Sylius est à jour <DoneAll style={{verticalAlign: 'top'}}/></span> : <span>Mettre à jour Sylius <RotateLeft style={{verticalAlign: 'top'}}/></span>,
                            color: isUpdateSylius ? '#006500' : '#ffc107',
                            loading: isLoadingSylius,
                            outlined: true,
                            onClick: isUpdateSylius ? () => {
                            } : updateSylius
                        } : false
                }
                promiseData={(resolve) => {
                    ApiHandler.get({route: 'api_setting_mark_list'},
                        (response) => {
                            let data = response.data;
                            for (let index in data) {
                                data[index].action = getAction(data[index]);
                            }
                            resolve(data);
                        });
                }}
            />

            <Dialog open={openDialog} maxWidth={'xl'} onClose={() => setOpenDialog(false)}>
                <DialogTitle style={{fontSize: 15}}>{mark ? 'Modifier une marque' : 'Ajouter une marque'}</DialogTitle>
                <DialogContent style={{minWidth: '30vw'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextFieldComponent id={'label'} handler={handlerForm}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextFieldComponent id={'code'} handler={handlerForm}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent color={'#5E6E82'} label={'Annuler'} onClick={() => setOpenDialog(false)} disabled={isLoadingForm}/>
                    <ButtonComponent label={'Enregistrer'} onClick={save} loading={isLoadingForm}/>
                </DialogActions>
            </Dialog>
        </ContentViewComponent>
    );
}

export default SettingMarkList;
